import { parseUrl } from '../utils/url'

export const REQUEST_WP_PAGE_DATA_SUCCESS = 'REQUEST_WP_PAGE_DATA_SUCCESS'
export const REQUEST_WP_BLOG_POST_DATA_SUCCESS =
  'REQUEST_WP_BLOG_POST_DATA_SUCCESS'
export const REQUEST_WP_BLOG_POSTS_DATA_SUCCESS =
  'REQUEST_WP_BLOG_POSTS_DATA_SUCCESS'
export const REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS =
  'REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS'
export const REQUEST_WP_PRESS_POSTS_DATA_SUCCESS =
  'REQUEST_WP_PRESS_POSTS_DATA_SUCCESS'
export const REQUEST_WP_AI_GLOSSARY_POSTS_DATA_SUCCESS =
  'REQUEST_WP_AI_GLOSSARY_POSTS_DATA_SUCCESS'
export const REQUEST_WP_GATED_RESOURCE_POST_DATA_SUCCESS =
  'REQUEST_WP_GATED_RESOURCE_POST_DATA_SUCCESS'
export const REQUEST_WP_CATEGORIES_DATA_SUCCESS =
  'REQUEST_WP_CATEGORIES_DATA_SUCCESS'
export const REQUEST_WP_AI_GLOSSARY_POST_DATA_SUCCESS =
  'REQUEST_WP_AI_GLOSSARY_POST_DATA_SUCCESS'

const intialState = {
  pages: {},
  // NOTE: the absence of data is used as a loading indicator
  blogPosts: null,
  pressPosts: null,
  caseStudyPosts: null,
  aiGlossaryPosts: null,
  gatedResourcePosts: null,
  categories: null
}

// NOTE: the wp slug for case study pages is `/blog/{slug}`, but we serve them on `/case-studies/{slug}`
// so re-write them here
function formatCaseStudyPost (post) {
  let formattedPost = { ...post }
  if (formattedPost.link) {
    formattedPost.link = formattedPost.link.replace('/blog/', '/case-studies/')
  }
  return formattedPost
}
export function formatGlossaryPost (post) {
  if (!post.link) {
    return post
  }
  const parsed = parseUrl(post.link)
  parsed.host = 'snips.ai'
  parsed.pathname = parsed.pathname.replace('/blog/', '/resources/glossaries/')
  if (!/\/$/.test(parsed.pathname)) {
    parsed.pathname += '/'
  }
  return {
    ...post,
    link: parsed.href
  }
}

export function formatBlogPost (post) {
  if (!post.link) {
    return post
  }
  const parsed = parseUrl(post.link)
  // since we were forced to change ~ WP_URL on wordpress to wp2.snips.ai
  // (no longer possible to use different value, i.e. snips.ai), blog post link values
  // contain the wp2 subdomain prefix - which we need to remove
  parsed.host = 'snips.ai'
  if (!/\/$/.test(parsed.pathname)) {
    parsed.pathname += '/'
  }
  return {
    ...post,
    link: parsed.href
  }
}

export default function wpData (state = intialState, action) {
  switch (action.type) {
    case REQUEST_WP_PAGE_DATA_SUCCESS:
      const newPages = { ...state.pages, [action.page.id]: action.page }
      return { ...state, pages: newPages }

    case REQUEST_WP_BLOG_POST_DATA_SUCCESS:
      const blogPostsWithNewPage = {
        ...state.blogPosts,
        [action.blogPost.id]: formatBlogPost(action.blogPost)
      }
      return { ...state, blogPosts: blogPostsWithNewPage }

    case REQUEST_WP_BLOG_POSTS_DATA_SUCCESS:
      // comes as an array, whereas we want them as a byId Object
      const newBlogPosts = action.blogPosts.reduce(
        (acc, blogPost) => {
          acc[blogPost.id] = formatBlogPost(blogPost)
          return acc
        },
        { ...state.blogPosts }
      )
      return { ...state, blogPosts: newBlogPosts }

    case REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS:
      const newCaseStudyPosts = {
        ...state.caseStudyPosts,
        [action.caseStudyPost.id]: formatCaseStudyPost(action.caseStudyPost)
      }
      return { ...state, caseStudyPosts: newCaseStudyPosts }

    case REQUEST_WP_AI_GLOSSARY_POSTS_DATA_SUCCESS:
      // comes as an array, whereas we want them as a byId Object
      const newAiGlossaryPosts = action.aiGlossaryPosts.reduce(
        (acc, aiGlossaryPost) => {
          acc[aiGlossaryPost.id] = formatGlossaryPost(aiGlossaryPost)
          return acc
        },
        {}
      )
      return { ...state, aiGlossaryPosts: newAiGlossaryPosts }

    case REQUEST_WP_AI_GLOSSARY_POST_DATA_SUCCESS:
      const aiGlossaryPostsWithNewPage = {
        ...state.aiGlossaryPosts,
        [action.aiGlossaryPost.id]: formatGlossaryPost(action.aiGlossaryPost)
      }
      return { ...state, aiGlossaryPosts: aiGlossaryPostsWithNewPage }

    case REQUEST_WP_PRESS_POSTS_DATA_SUCCESS:
      // comes as an array, whereas we want them as a byId Object
      const newPressPosts = action.pressPosts.reduce((acc, pressPost) => {
        acc[pressPost.id] = pressPost
        return acc
      }, {})
      return { ...state, pressPosts: newPressPosts }

    case REQUEST_WP_GATED_RESOURCE_POST_DATA_SUCCESS:
      const newGatedResourcePosts = {
        ...state.gatedResourcePosts,
        [action.gatedResourcePost.id]: action.gatedResourcePost
      }
      return { ...state, gatedResourcePosts: newGatedResourcePosts }

    case REQUEST_WP_CATEGORIES_DATA_SUCCESS:
      return { ...state, categories: action.categories }
    default:
      return state
  }
}

export function requestWpPageDataSuccess (page) {
  return {
    type: REQUEST_WP_PAGE_DATA_SUCCESS,
    page
  }
}

export function requestWpBlogPostDataSuccess (blogPost) {
  return {
    type: REQUEST_WP_BLOG_POST_DATA_SUCCESS,
    blogPost
  }
}

export function requestWpAiGlossaryPostDataSuccess (aiGlossaryPost) {
  return {
    type: REQUEST_WP_AI_GLOSSARY_POST_DATA_SUCCESS,
    aiGlossaryPost
  }
}

export function requestWpCaseStudyPostDataSuccess (caseStudyPost) {
  return {
    type: REQUEST_WP_CASE_STUDY_POST_DATA_SUCCESS,
    caseStudyPost
  }
}

export function requestWpBlogPostsDataSuccess (blogPosts) {
  return {
    type: REQUEST_WP_BLOG_POSTS_DATA_SUCCESS,
    blogPosts
  }
}

export function requestWpPressPostsDataSuccess (pressPosts) {
  return {
    type: REQUEST_WP_PRESS_POSTS_DATA_SUCCESS,
    pressPosts
  }
}

export function requestWpAiGlossaryPostsDataSuccess (aiGlossaryPosts) {
  return {
    type: REQUEST_WP_AI_GLOSSARY_POSTS_DATA_SUCCESS,
    aiGlossaryPosts
  }
}

export function requestWpGatedResourcePostDataSuccess (gatedResourcePost) {
  return {
    type: REQUEST_WP_GATED_RESOURCE_POST_DATA_SUCCESS,
    gatedResourcePost
  }
}

export function requestWpCategoriesDataSuccess (categories) {
  return {
    type: REQUEST_WP_CATEGORIES_DATA_SUCCESS,
    categories
  }
}
